import { Box, Stack } from "@mui/system";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import AddAndRemove from '../add-and-remove';

const TaskCreatedTrigger = () => {
    const conditions = useAppSelector((state) => state.AutomationReducer.conditions);

    return (
        <Stack direction="row" justifyContent={"space-between"} sx={{ fontSize: "24px" }}>
            <Box>When item created</Box>
            <AddAndRemove elements={conditions} index={0} type={"trigger"} />
        </Stack>

    )
}
export default TaskCreatedTrigger